<template>
  <QPaginatedSearchDropdown :key="resetKey" :value="value" :list-getter="getMachineModelListFromFilter" :filter="filter"
    :min-search-char-limit="0" :allow-create="allowCreate" :externaledit="externaledit" :clearable="clearable"
    :multiple="multiple" :returnobject="returnobject" :disabled="disabled" :outlined="outlined" :dense="dense"
    :loading="createLoading || loading" valuekey="Id" textkey="Name"
    :label="label ? label : $t('servicesystem.common_objects.model.machine_model')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.model.search_field_label')"
    :rules="rules" @input="e => $emit('input', e)" @change="e => $emit('change', e)" @create="e => createNew(e)"
    @FocusState="e => $emit('FocusState', e)">
    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="18">$machine_model</v-icon>
    </template>
    <template v-slot:append-outer>
      <slot name="append-outer" />
    </template>
  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";

export default {
  name: "MachineModelSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    rules: Array,
    allowCreate: Boolean,
    hideIcon: Boolean,
    outlined: Boolean,
    dense: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI],

  data() {
    return {
      createLoading: false,
      resetKey: 1,
    };
  },

  methods: {
    async createNew({ value, onComplete }) {
      this.createLoading = true;
      const dto = {
        Name: value,
        SupplierId: this.filter?.SupplierIdList?.[0] ?? undefined, //pick first supplier from filter if provided
        MachineTypeId: this.filter?.MachineTypeIdList?.[0] ?? undefined, //pick first machinetype from filter if provided
      };
      clientAPI.methods.createModel(dto)
        .then(async response => {
          var val = this.returnobject ? response : response.Id;
          if (this.multiple) {
            val = [...this.value, val];
          }
          this.$emit('input', val);
          this.$emit('change', val);
          await onComplete();
          //reset required to force reload while in editmode
          if (this.externaledit) {
            this.resetKey++;
          }
        })
        .finally(() => {
          this.createLoading = false;
        });
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>